const SEPARATOR = '-$-';

export const generateGroupItems = (groupsWithItems) => {
  const groups = {};
  let index = 0;
  (groupsWithItems || []).forEach((group) => {
    groups[group.id] = group.items.map((item) => {
      const id = item?.id || item;
      index += 1;
      return `${id}${SEPARATOR}${index}`;
    });
  });
  return groups;
};

export const getId = (id) => {
  const seperatedId = id?.split(SEPARATOR);
  if (seperatedId?.length < 3) return seperatedId[0];
  return seperatedId.slice(0, -1).join(SEPARATOR);
};

export const generateArrangedGroup = (groupedItems) => {
  return Object.keys(groupedItems).map((groupId) => {
    return {
      id: groupId,
      items: groupedItems[groupId].map((item) => getId(item))
    };
  });
};

export const findItem = (item, active) => {
  return item === active.id;
};
